<template>
  <div class="view-selector">
    <p v-if="force || timestamp || published || approved">
      <el-dropdown
        :disabled="!force && !timestamp"
        @command="viewDev"
        placement="bottom"
        :tabindex="-1">
        <el-button-group class="view-selector-view-group"
          :class="{
            'view-selector-view': !view,
            'view-selector-compare': compare === 'dev',
          }">
          <el-tooltip placement="top" effect="light"
            :disabled="force || !!timestamp">
            <template slot="content" v-if="status === 'deleted'">
              Already <em>deleted</em>
            </template>
            <template slot="content" v-else>
              Not <em>created</em> yet
            </template>
            <el-button class="view-selector-view-button"
              :disabled="!force && !timestamp"
              :icon="viewIcon('dev')"
              @click="viewDev()">
              Development<br/>
              <span v-if="!force" class="view-selector-timestamp">{{
                timestamp ? new Date(timestamp).toLocaleString() : 'deleted'
              }}</span>
            </el-button>
          </el-tooltip>
          <el-button class="el-dropdown__caret-button"
            :disabled="!force && !timestamp">
            <i class="el-dropdown__icon el-icon-arrow-down"></i>
          </el-button>
        </el-button-group>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="null"
            :disabled="!force && !timestamp"
            :icon="viewIcon('dev')">
            View development
          </el-dropdown-item>
          <el-dropdown-item :command="'pub'"
            :disabled="!force && (!timestamp || !published)"
            :icon="viewIcon('dev', 'pub')">
            Compare to published
          </el-dropdown-item>
          <el-dropdown-item :command="'prod'"
            :disabled="!force && (!timestamp || !approved)"
            :icon="viewIcon('dev', 'prod')">
            Compare to production
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        :disabled="!force && !published"
        @command="viewPub"
        placement="bottom"
        :tabindex="-1">
        <el-button-group class="view-selector-view-group"
          :class="{
            'view-selector-view': view === 'pub',
            'view-selector-compare': compare === 'pub',
          }">
          <el-tooltip placement="top" effect="light"
            :disabled="force">
            <template slot="content" v-if="status === 'published'">
              Waiting for approval
            </template>
            <template slot="content" v-if="status === 'approved'">
              Already in production
            </template>
            <template slot="content" v-if="status === 'rejected'">
              Rejected from production
            </template>
            <template slot="content" v-if="status === 'deleted'">
              Waiting for deletion
            </template>
            <template slot="content" v-if="!status">
              No <em>published</em> version
            </template>
            <el-button class="view-selector-view"
              :type="status === 'published' ? 'primary' : status === 'approved' ? 'success' : status === 'rejected' ? 'warning' : status === 'deleted' ? 'danger' : undefined"
              :disabled="!force && !published"
              :icon="viewIcon('pub')"
              @click="viewPub()">
              Published<br/>
              <span v-if="!force" class="view-selector-timestamp">{{
                published ? new Date(published).toLocaleString() : 'not published'
              }}</span>
            </el-button>
          </el-tooltip>
          <el-button class="el-dropdown__caret-button"
            :disabled="!force && !published">
            <i class="el-dropdown__icon el-icon-arrow-down"></i>
          </el-button>
        </el-button-group>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="null"
            :disabled="!force && !published"
            :icon="viewIcon('pub')">
            View published
          </el-dropdown-item>
          <el-dropdown-item :command="'dev'"
            :disabled="!force && (!published || !timestamp)"
            :icon="viewIcon('pub', 'dev')">
            Compare to development
          </el-dropdown-item>
          <el-dropdown-item :command="'prod'"
            :disabled="!force && (!published || !approved)"
            :icon="viewIcon('pub', 'prod')">
            Compare to production
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        :disabled="!force && !approved"
        @command="viewProd"
        placement="bottom"
        :tabindex="-1">
        <el-button-group class="view-selector-view-group"
          :class="{
            'view-selector-view': view === 'prod',
            'view-selector-compare': compare === 'prod',
          }">
          <el-tooltip placement="top" effect="light"
            :disabled="force || !!approved">
            <template slot="content">
              Not in <em>production</em>
            </template>
            <el-button class="view-selector-view"
              :disabled="!force && !approved"
              :icon="viewIcon('prod')"
              @click="viewProd()">
              Production<br/>
              <span v-if="!force" class="view-selector-timestamp">{{
                approved ? new Date(approved).toLocaleString() : 'not in production'
              }}</span>
            </el-button>
          </el-tooltip>
          <el-button class="el-dropdown__caret-button"
            :disabled="!force && !approved">
            <i class="el-dropdown__icon el-icon-arrow-down"></i>
          </el-button>
        </el-button-group>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="null"
            :disabled="!force && !approved"
            :icon="viewIcon('prod')">
            View production
          </el-dropdown-item>
          <el-dropdown-item :command="'dev'"
            :disabled="!force && (!approved || !timestamp)"
            :icon="viewIcon('prod', 'dev')">
            Compare to development
          </el-dropdown-item>
          <el-dropdown-item :command="'pub'"
            :disabled="!force && (!approved || !published)"
            :icon="viewIcon('prod', 'pub')">
            Compare to published
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </p>
    <p v-if="!force">
      <el-button-group v-if="!view && (timestamp || newItem)">
        <el-button type="primary"
          @click="$emit('save')">
          {{newItem ? 'Create' : edit ? 'Edit' : 'Save'}}
        </el-button>
        <el-tooltip placement="top" effect="light"
          :disabled="!!timestamp">
          <template slot="content" v-if="status == 'deleted'">
            already <em>deleted</em>
          </template>
          <template slot="content" v-else-if="!timestamp">
            Not <em>created</em> yet
          </template>
          <el-button type="danger"
            :disabled="!timestamp"
            @click="handleDeleted">Delete</el-button>
        </el-tooltip>
        <el-tooltip placement="top" effect="light"
          :disabled="!!timestamp && timestamp !== published">
          <template slot="content" v-if="status == 'deleted'">
            already <em>deleted</em>
          </template>
          <template slot="content" v-else-if="!timestamp">
            Not <em>created</em> yet
          </template>
          <template slot="content" v-else>
            Already <em>published</em>
          </template>
          <el-button type="success" v-if="publishable || discrete"
            :disabled="!timestamp || timestamp === published"
            @click="$emit('publish')">Publish</el-button>
        </el-tooltip>
        <el-tooltip placement="top" effect="light"
          :disabled="!!timestamp">
          <template slot="content" v-if="!timestamp">
            Not <em>created</em> yet
          </template>
          <el-button type="success"
            :disabled="!timestamp"
            @click="$emit('test')">Test</el-button>
        </el-tooltip>
        <el-tooltip placement="top" effect="light"
          :disabled="!!timestamp">
          <template slot="content" v-if="!timestamp">
            Not <em>created</em> yet
          </template>
          <el-button type="warning"
            :disabled="!timestamp"
            @click="$emit('untest')">Untest</el-button>
        </el-tooltip>
      </el-button-group>
      <el-button-group v-if="view === 'pub' && published">
        <template v-if="admin">
          <el-tooltip placement="top" effect="light"
            v-if="publishable"
            :disabled="compare !== 'dev' && status !== 'approved'">
            <template slot="content" v-if="status === 'approved'">
              Already <em>approved</em>
            </template>
            <template slot="content" v-else>
              Cannot <em>publish</em> while comparing with <em>development</em> version
            </template>
            <el-button type="success"
              :disabled="compare === 'dev' || status === 'approved'"
              @click="handleApprove">{{ status === 'deleted' ? 'Delete' : 'Approve' }}</el-button>
          </el-tooltip>
          <el-tooltip placement="top" effect="light"
            v-if="publishable"
            :disabled="compare !== 'dev' && status !== 'approved'">
            <template slot="content" v-if="status === 'approved'">
              Already <em>approved</em>
            </template>
            <template slot="content" v-else>
              Cannot <em>reject</em> while comparing with <em>development</em> version
            </template>
            <el-button type="warning"
              :disabled="compare === 'dev' || status === 'approved' || status === 'rejected'"
              @click="$emit('reject')">Reject</el-button>
          </el-tooltip>
        </template>
        <template v-if="publishable || discrete">
          <el-button type="danger" v-if="status === 'approved'"
            @click="handleUnprod">Unprod</el-button>
          <el-button type="danger" v-else
            @click="$emit('unpublish')">Unpublish</el-button>
        </template>
        <el-tooltip placement="top" effect="light"
          :disabled="status !== 'deleted' && published !== timestamp">
          <template slot="content" v-if="status === 'deleted'">
            Already <em>deleted</em>
          </template>
          <template slot="content" v-else>
            Same as <em>development</em> version
          </template>
          <el-button type="primary"
            :disabled="status === 'deleted' || published === timestamp"
            @click="handleRestore('pub')">Restore</el-button>
        </el-tooltip>
      </el-button-group>
      <el-button-group v-if="view === 'prod' && approved">
        <el-button type="success" v-if="admin && publishable"
          @click="handleDisapprove">Disapprove</el-button>
        <el-tooltip placement="top" effect="light"
          :disabled="approved !== timestamp">
          <template slot="content">
            Same as <em>development</em> version
          </template>
          <el-button type="primary"
            :disabled="approved === timestamp"
            @click="handleRestore('prod')">Restore</el-button>
        </el-tooltip>
      </el-button-group>
    </p>
  </div>
</template>

<script>
import State from '../stores/state.js'

export default {
  name: 'ViewSelector',
  props: {
    view: String,
    compare: String,
    object: Object,
    newItem: Boolean,
    edit: Boolean,
    publishable: Boolean,
    discrete: Boolean,
    force: Boolean,
    name: String,
    deleteMessage: String,
    unprodMessage: String,
    approveMessage: String,
    disapproveMessage: String,
    restoreMessage: String,
    restorePublishedMessage: String,
    restoreApprovedMessage: String,
  },
  data () {
    return {
      state: State.state,
    }
  },
  computed: {
    timestamp () { return this.object && this.object.timestamp },
    published () { return this.object && this.object.published },
    approved () { return this.object && this.object.approved },
    all () {
      return {
        dev: this.timestamp,
        pub: this.published,
        prod: this.approved,
      }
    },
    status () { return this.object && this.object.status },
    admin () { return this.state.user && this.state.user.role === 'admin' },
  },
  watch: {
    timestamp (development) {
      if (!development) this.checkStatus(undefined, 'pub', 'prod')
    },
    published (published) {
      if (!published) this.checkStatus('pub', undefined, 'prod')
    },
    approved (approved) {
      if (!approved) this.checkStatus('prod', 'pub', undefined)
    },
  },
  methods: {
    swapView () {
      let view = this.compare === 'dev' ? undefined : this.compare
      let compare = this.view || 'dev'
      this.$emit('update:view', view)
      this.$emit('update:compare', compare)
      this.$emit('view', view, compare)
    },
    changeView (view, compare) {
      compare = compare || undefined
      this.$emit('update:view', view)
      this.$emit('update:compare', compare)
      this.$emit('update', view, compare)
    },
    viewDev (compare) { this.changeView(undefined, compare) },
    viewPub (compare) { this.changeView('pub', compare) },
    viewProd (compare) { this.changeView('prod', compare) },
    checkStatus (status, first, second) {
      if (this.force) return
      let view = this.view, compare = this.compare
      if (view === status) {
        if (this.all[first || 'dev']) view = first
        else if (this.all[second || 'dev']) view = second
      }
      if (compare === (status || 'dev')) compare = undefined
      if (view !== this.view) this.$emit('update:view', view)
      if (compare !== this.compare) this.$emit('update:compare', compare)
      if (view !== this.view || compare !== this.compare) {
        this.$emit('update', view, compare)
      }
    },
    getMessage (left, right, first, second) {
      if (first) return first
      if (second) return second
      if (this.name) return left + this.name + right
    },
    handleDeleted () {
      let message = this.getMessage('This ', ' will be definitely deleted',
        this.deleteMessage)
      if (!message) return this.$emit('delete')
      this.$confirm(message, 'Delete', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => { this.$emit('delete') })
    },
    handleUnprod () {
      let message = this.getMessage('This ', ' will be removed from production',
        this.unprodMessage)
      if (!message) return this.$emit('unprod')
      this.$confirm(message, 'Remove from production', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => { this.$emit('unprod') })
    },
    handleApprove () {
      if (this.status === 'deleted') {
        let message = this.getMessage('This ',
          ' will be definitely deleted form production',
          this.approveDeleteMessage)
        if (!message) return this.$emit('approve')
        this.$confirm(message, 'Approve deletion', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => { this.$emit('approve') })
      } else {
        let message = this.getMessage('This ', ' will be in production',
          this.approveMessage)
        if (!message) return this.$emit('approve')
        this.$confirm(message, 'Approve', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => { this.$emit('approve') })
      }
    },
    handleDisapprove () {
      let message = this.getMessage('This ', ' will be removed from production',
        this.disapproveMessage)
      if (!message) return this.$emit('disapprove')
      this.$confirm(message, 'Disapprove', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => { this.$emit('disapprove') })
    },
    handleRestore (value) {
      let message = this.getMessage('The development version of this ',
        ' will be replaced by its ' +
        (value === 'pub' ? 'published' : 'produtcion') + ' version',
        value === 'pub' ? this.restorePublishedMessage
          : this.restoreApprovedMessage, this.disapproveMessage)
      if (!message) return this.$emit('restore', value)
      this.$confirm(message, 'Restore', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => { this.$emit('restore', value) })
    },
    viewIcon (view, compare) {
      if (this.force) return 'el-icon-view'
      let timestamp = this.all[view]
      if (!compare) return !timestamp ? 'el-icon-circle-close' : view === 'dev' ? 'el-icon-edit' : view === 'prod' ? 'el-icon-notebook-2' : this.status === 'published' ? 'el-icon-document-add' : this.status === 'approved' ? 'el-icon-document-checked' : this.status === 'rejected' ? 'el-icon-document-delete' : 'el-icon-delete'
      let other = this.all[compare]
      return !timestamp || !other ? 'el-icon-circle-close' : timestamp === other ? 'el-icon-circle-check' : 'el-icon-warning-outline'
    },
  },
}
</script>

<style lang="scss">
  @import "../element-variables.scss";

  .view-selector > p {
    text-align: center;
    > .el-button-group {
      justify-content: center;
    }
  }

  .view-selector-timestamp {
    color: $--color-text-placeholder;
    font-size: 10px;
  }

  .view-selector-view-group {
    margin: 0 5px;
    height: auto;
    &.view-selector-view {
      > .el-button {
        margin: -2px 0;
        border-top: solid 3px $--color-primary;
        border-bottom: solid 3px $--color-primary;
        &:first-child {
          border-left: solid 3px $--color-primary;
        }
        &:last-child {
          border-right: solid 3px $--color-primary;
        }
      }
    }
    &.view-selector-compare {
      > .el-button {
        margin: -2px 0;
        border-top: solid 3px $--color-warning;
        border-bottom: solid 3px $--color-warning;
        &:first-child {
          border-left: solid 3px $--color-warning;
        }
        &:last-child {
          border-right: solid 3px $--color-warning;
        }
      }
    }
  }
</style>
